import { useState } from 'react';

/**
 * Custom hook for managing suggestion selection state
 * Used for multi-select suggestions with send button
 */
export const useSuggestionState = () => {
    const [selectedSuggestions, setSelectedSuggestions] = useState<string[]>([]);
    const [pendingSuggestions, setPendingSuggestions] = useState<string[] | null>(null);
    const [renderKey, setRenderKey] = useState(0);

    const handleSuggestionClick = (text: string) => {
        setSelectedSuggestions((prev) => {
            const isSelected = prev.includes(text);
            return isSelected 
                ? prev.filter((t) => t !== text) 
                : [...prev, text];
        });
        
        // Force re-render (reset to 0 after 10000 to prevent overflow)
        setRenderKey(k => (k + 1) % 10000);
    };

    const clearSuggestions = () => {
        setSelectedSuggestions([]);
        setPendingSuggestions(null);
    };

    return {
        selectedSuggestions,
        pendingSuggestions,
        renderKey,
        handleSuggestionClick,
        setPendingSuggestions,
        clearSuggestions,
        setSelectedSuggestions
    };
};



